import React from "react";
import { Box, useMediaQuery, useTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { red, grey, green, blue } from "@material-ui/core/colors";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

const useStylesLegend = makeStyles((theme) => ({
  greenCircle: {
    color: green[600],
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  redCircle: {
    color: red[600],
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  greyCircle: {
    color: grey[600],
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  whiteCircle: {
    color: grey[100],
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  blueCircle: {
    color: theme.palette.info.main,
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  legendContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(1),
  },
  legendContainerMobile: {
    display: "flex",
    justifyContent: "center",
  },
  legendBox: {
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(2),
    fontSize: 12,
  },
}));

/**
 * Shared legend component for track car status indicators.
 * Used in Crew App, Manager App, and common views.
 */
export const TrackLegend = ({ selectedTrack }) => {
  const classes = useStylesLegend();
  const theme = useTheme();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div
      className={
        isSmall ? classes.legendContainerMobile : classes.legendContainer
      }
    >
      <span className={classes.legendBox}>
        <FiberManualRecordIcon className={classes.greenCircle} />
        &nbsp;Completed
      </span>
      <span className={classes.legendBox}>
        <FiberManualRecordIcon className={classes.greyCircle} />
        &nbsp;Placed
      </span>
      <span className={classes.legendBox}>
        <FiberManualRecordIcon className={classes.redCircle} />
        &nbsp;Released
      </span>
      <span className={classes.legendBox}>
        <FiberManualRecordIcon className={classes.blueCircle} />
        &nbsp;Matched
      </span>
      <span className={classes.legendBox}>
        <Box
          display="inline-flex"
          mr={0.5}
          style={{
            width: 20,
            height: 14,
            border: `1px solid ${grey[400]}`,
            borderRadius: 2,
            position: 'relative',
            overflow: 'hidden',
            backgroundColor: theme.palette.background.paper
          }}
        >
          <Box
            style={{
              width: 5,
              height: '100%',
              backgroundColor: blue[500],
              position: 'absolute',
              left: 0
            }}
          />
        </Box>
        Account (Left)
      </span>
      <span className={classes.legendBox}>
        <Box
          display="inline-flex"
          mr={0.5}
          style={{
            width: 20,
            height: 14,
            border: `1px solid ${grey[400]}`,
            borderRadius: 2,
            position: 'relative',
            overflow: 'hidden',
            backgroundColor: theme.palette.background.paper
          }}
        >
          <Box
            style={{
              width: 5,
              height: '100%',
              backgroundColor: green[500],
              position: 'absolute',
              right: 0
            }}
          />
        </Box>
        Product (Right)
      </span>
      {selectedTrack && (
        <span className={classes.legendBox}>
          <FiberManualRecordIcon className={classes.whiteCircle} />
          &nbsp;Selected
        </span>
      )}
    </div>
  );
};

